enum BookmarkType {
  Page = 'page',
  Juz = 'juz',
  Surah = 'surah',
  Ayah = 'ayah',
}
export default BookmarkType;
